(function () {
  var root = document.documentElement;
  root.classList.add('zr-collection');
  var KEY = 'zr-grid-size';
  function isMobile() { return window.matchMedia('(max-width: 749px)').matches; }
  function get() { try { return localStorage.getItem(KEY); } catch (e) { return null; } }
  function set(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }
  // stored value: 'small' (4 per row desktop, 2 on phones) or 'large' (2 per row desktop, 1 on phones)
  function apply() {
    var large = get() === 'large';
    root.classList.toggle('zr-grid-2', large && !isMobile());
    root.classList.toggle('zr-grid-1', large && isMobile());
    document.querySelectorAll('.zr-grid-toggle button').forEach(function (b) {
      var n = b.getAttribute('data-size') === 'large' ? large : !large;
      b.setAttribute('aria-pressed', n ? 'true' : 'false');
      b.textContent = b.getAttribute('data-size') === 'large' ? (isMobile() ? '1' : '2') : (isMobile() ? '2' : (window.matchMedia('(min-width: 990px)').matches ? '4' : '3'));
    });
  }
  function build() {
    var wrap = document.createElement('div');
    wrap.className = 'zr-grid-toggle';
    wrap.innerHTML = '<span class="zr-grid-toggle__label">View</span>' +
      '<button type="button" data-size="small" aria-label="More products per row"></button>' +
      '<button type="button" data-size="large" aria-label="Bigger photos"></button>';
    wrap.addEventListener('click', function (e) {
      var b = e.target.closest('button');
      if (!b) return;
      set(b.getAttribute('data-size'));
      apply();
    });
    return wrap;
  }
  function ensure() {
    var added = false;
    var f = document.querySelector('#main-collection-filters .facets__form, #main-search-filters .facets__form');
    if (f && !f.querySelector(':scope > .zr-grid-toggle')) { f.appendChild(build()); added = true; }
    var c = document.querySelector('#main-collection-filters .facets-container, #main-search-filters .facets-container');
    if (c && !c.querySelector(':scope > .zr-grid-toggle')) { c.appendChild(build()); added = true; }
    if (added) apply();
  }
  apply();
  document.addEventListener('DOMContentLoaded', function () {
    ensure();
    var host = document.getElementById('main-collection-filters') || document.getElementById('main-search-filters');
    if (host) new MutationObserver(ensure).observe(host, { childList: true, subtree: true });
  });
  window.matchMedia('(max-width: 749px)').addEventListener('change', apply);
})();
